<template>
  <!-- Listing -->
  <div class="row">
    <div v-if="isLoading" class="col"><i class="fas fa-spinner fa-spin"></i> Loading...</div>
    <div v-else class="col">
      <!-- Header -->
      <div class="row custom-header">
        <div class="col-4">
          <z-search v-model.trim="searchTerm" name="search" label="" placeholder="Search" :readonly="isLoading" />
        </div>
        <div class="col"></div>
        <div class="col-2">
          <button type="button" class="btn btn-primary btn-sm mt-1 ms-3" @click="addInsurance">Add</button>
        </div>
        <div class="col-5">
          <div class="input-group">
            <span class="input-group-text">Push To:</span>
            <select v-model="selectedDestination" class="form-select">
              <option v-for="item of destinations" :key="item.app" :value="item.appNumber">
                {{ item.appName }}
              </option>
            </select>
            <button type="button" class="btn btn-primary btn-sm" @click="pushInsurance">Push</button>
          </div>
        </div>
      </div>
      <!-- Listing -->
      <div class="custom-list-wrapper">
        <ul :id="counter" class="custom-list">
          <li
            v-for="company of companies"
            :key="company.insurance"
            class="custom-insurance"
            :class="{ 'custom-highlight': company.isSelected }"
            @click="showInsurance(company.insurance)"
          >
            <div class="row">
              <div class="col-1 text-center">
                <span>{{ company.insurance }}</span>
              </div>
              <div class="col">
                <input
                  v-if="isEditing && parseInt(company.insurance) === parseInt(currentInsurance)"
                  v-model="name"
                  class="form-control form-control-sm"
                />
                <span v-else>{{ company.insuranceName }}</span>
              </div>
              <div class="col-1 text-center custom-actions">
                <div v-if="isEditing && parseInt(company.insurance) === parseInt(currentInsurance)" @click="performSave(company.insurance)">
                  <i class="fas fa-check custom-check"></i>
                </div>
                <div v-else @click="removeInsurance(company)">
                  <i class="fas fa-trash custom-trash"></i>
                </div>
                <div v-if="!isEditing" class="ms-3" @click="editInsurance(company)">
                  <i class="fas fa-pencil-alt custom-edit"></i>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <confirm-delete
    v-model="actionDelete"
    :confirm-title="confirmDeleteTitle"
    :confirm-action="confirmDeleteAction"
    :confirm-question="confirmDeleteQuestion"
    @closing="closeModal"
    @proceed="performDeletion"
  />
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { lookupStore } from '@/stores/lookup'
import { appsStore } from '@/stores/apps'
import ZSearch from '@/components/utilities/elements/Search.vue'
import ConfirmDelete from '@/components/utilities/elements/ConfirmDialog.vue'
export default {
  name: 'InsuranceListing',
  components: {
    ZSearch,
    ConfirmDelete
  },
  data() {
    return {
      confirmDeleteTitle: 'Confirm Insurance Deletion',
      confirmDeleteAction: 'Delete',
      confirmDeleteQuestion: 'Are you sure you wish to Delete this Insurance?',
      actionDelete: null,
      counter: 0,
      currentInsurance: null,
      isEditing: false,
      selectedDestination: 'ALL'
    }
  },
  emits: ['push', 'add', 'show', 'remove', 'saved'],
  async mounted() {
    await this.getApps('ADAS')
  },
  computed: {
    ...mapState(lookupStore, ['loading', 'insurance', 'search', 'newInsurance']),
    ...mapState(appsStore, ['apps']),
    isLoading() {
      let _is = false
      if (this.loading) {
        if (this.loading.insurance) {
          _is = this.loading.insurance
        }
      }
      return _is
    },
    destinations() {
      let _dest = []
      _dest.push({
        app: 0,
        appName: 'All',
        appNumber: 'ALL'
      })
      if (this.apps) {
        this.apps.forEach((element) => {
          _dest.push({
            app: element.app,
            appName: element.appName,
            appNumber: element.appNumber
          })
        })
      }
      console.log('Destinations', this.apps)
      return _dest
    },
    companies() {
      return this.insurance
    },
    searchTerm: {
      get() {
        return this.search
      },
      set(value) {
        if (value.trim() === '') {
          this.setInsurance({
            name: 'reset',
            value: null
          })
          this.getInsurance()
        } else {
          this.setInsurance({
            name: 'search',
            value: value
          })
        }
      }
    },
    name: {
      get() {
        let _name = null
        if (this.newInsurance) {
          _name = this.newInsurance.insuranceName
        }
        return _name
      },
      set(value) {
        this.setInsurance({
          name: 'name',
          value: value
        })
      }
    }
  },
  methods: {
    ...mapActions(appsStore, ['getApps']),
    ...mapActions(lookupStore, ['setInsurance', 'getInsurance', 'saveInsurance']),
    closeModal() {
      this.actionDelete = null
    },
    pushInsurance() {
      this.$emit('push', this.selectedDestination)
    },
    showInsurance(id) {
      this.$emit('show', id)
    },
    addInsurance() {
      this.setInsurance({
        name: 'search',
        value: ''
      })
      this.$emit('add')
    },
    editInsurance(company) {
      console.log('Edit Insurance', company)
      this.currentInsurance = company.insurance
      this.setInsurance({
        name: 'id',
        value: company.insurance
      })
      this.setInsurance({
        name: 'name',
        value: company.insuranceName
      })
      this.isEditing = true
    },
    async performSave() {
      console.log('Save Insurance', this.newInsurance)
      await this.saveInsurance()
      this.currentInsurance = null
      this.isEditing = false
      this.$emit('saved', this.searchTerm)
    },
    performDeletion() {
      this.$emit('remove', this.currentInsurance)
      this.setInsurance({
        name: 'search',
        value: ''
      })
      this.actionDelete = null
      this.currentInsurance = null
    },
    removeInsurance(company) {
      this.currentInsurance = company.insurance
      this.confirmDeleteQuestion = `Are you sure you wish to Delete ${company.insuranceName}?`
      this.actionDelete = true
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-header {
  padding-bottom: 5px;
  margin-bottom: 5px;
  border-bottom: 1px solid #ced4da;
  background-color: white;
  z-index: 10;
}
.custom-list-wrapper {
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 450px;
}
.custom-list {
  list-style: none;
  li {
    padding-top: 8px;
    padding-bottom: 8px;
  }
}
.custom-insurance {
  cursor: pointer;
  &:hover {
    background-color: #f8f9fa;
  }
}
.custom-row {
  width: 100%;
  display: inline;
}
.custom-label {
  font-size: 1.1em;
  font-weight: 500;
}
.custom-trash {
  color: rgb(173, 0, 0);
  :hover {
    cursor: pointer;
  }
}
.custom-highlight {
  background-color: #fdff9d;
}
.custom-actions {
  display: inline-flex;
}
.custom-edit {
  color: rgb(0, 40, 173);
  :hover {
    cursor: pointer;
  }
}
.custom-check {
  color: rgb(0, 173, 0);
  :hover {
    cursor: pointer;
  }
}
</style>
